var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.candidate
    ? _c("table", { staticClass: "ui definition keyValueTable table" }, [
        _vm.candidate.operator_name
          ? _c("tr", [
              _c("td", [_vm._v("担当者名")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.candidate.operator_name))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("お客様向け立候補コメント")]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "linebreak" }, [
              _vm._v(_vm._s(_vm.candidate.message)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.planDetail
          ? _c("tr", [
              _c("td", [_vm._v("コース内容")]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "linebreak" }, [
                  _vm._v(_vm._s(_vm.planDetail)),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.candidate.price
          ? _c("tr", [
              _c("td", [_vm._v("価格(税込)")]),
              _vm._v(" "),
              _c("td", [
                _vm.candidate.price
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("formatCurrency")(_vm.candidate.price)) +
                          "円"
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.candidate.dish_count
          ? _c("tr", [
              _c("td", [_vm._v("品数")]),
              _vm._v(" "),
              _c("td", [
                _vm.candidate.dish_count
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.candidate.dish_count) + "品"),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }